import React, { Fragment, PureComponent } from 'react';
import type { Office } from './types';
import { read } from '../../utils/request';
import { ContentBody } from '../shared/content';
import Loading from '../shared/loading';
import { withLocalePrefix } from 'shared/utils/translation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/checkbox_tree'. 'node_modules/@grnhse/seedling/lib/azalea/components/checkbox_tree.js' implicitly has an 'any' type.
import CheckboxTree from '@grnhse/seedling/lib/azalea/components/checkbox_tree';
import styled from 'styled-components';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import type { DataCollectionRuleInterface } from '../data_collection_rules/data_collection_rule';
import type { DataRetentionRuleInterface } from '../data_retention_rules/data_retention_rule';
import CheckboxWithLabel from '@grnhse/seedling/lib/azalea/components/checkbox_with_label';

const t = withLocalePrefix('gdpr.shared');

type Props = {
  allOfficesPath: string;
  error: boolean;
  offices?: Array<Office>;
  rule: DataCollectionRuleInterface | DataRetentionRuleInterface;
  onToggleAllOffices: any;
  onChangeSelectedOffices: any;
  short?: boolean;
};

type State = {
  offices: Array<Office>;
  loaded: boolean;
};

const OfficesContainer = styled.div`
  height: ${(props) =>
    // @ts-expect-error - TS2339 - Property 'minimized' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, any>'. | TS2339 - Property 'short' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, any>'.
    props.minimized ? '2.6em' : props.short ? '15rem' : '25rem'};
  overflow-y: scroll;
  border: 1px solid ${/* @ts-expect-error */ ''}
    ${(props) => (props.error ? colors.darkRed : colors.lightGrey)};
  padding: 5px 10px;
  background-color: ${colors.white};
`;

export default class OfficesSelector extends PureComponent<Props, State> {
  state = {
    offices: [],
    loaded: false,
  };

  async componentDidMount() {
    if (this.props.offices && this.props.offices.length) {
      this.setState({ offices: this.props.offices, loaded: true });
    } else {
      const response = await read(this.props.allOfficesPath);
      this.setState({ offices: response.data.results, loaded: true });
    }
  }

  render() {
    const {
      props: {
        error,
        onChangeSelectedOffices,
        onToggleAllOffices,
        rule,
        short,
      },
      state: { loaded, offices },
    } = this;

    const officesCopy = JSON.parse(JSON.stringify(offices));

    return (
      <Fragment>
        <ContentBody>
          {!loaded ? (
            <Loading />
          ) : (
            <ContentBody>
              <OfficesContainer
                // @ts-expect-error - TS2769 - No overload matches this call.
                minimized={rule.all_offices}
                error={error}
                short={short}
              >
                <CheckboxWithLabel
                  label={t('all_offices')}
                  name="all_offices"
                  onChange={(e) => onToggleAllOffices(e.currentTarget.checked)}
                  checked={rule.all_offices}
                />
                {rule.all_offices || (
                  <CheckboxTree
                    nodes={officesCopy}
                    onChange={onChangeSelectedOffices}
                    checked={this.props.rule.office_ids}
                    expanded={this.props.rule.office_ids}
                  />
                )}
              </OfficesContainer>
            </ContentBody>
          )}
        </ContentBody>
      </Fragment>
    );
  }
}
